import { useState } from "react";
import { Navigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { STAGES, STAGE_COLOR } from "@/constants/crm";

const inputCls = "h-11 w-full rounded-lg border border-zinc-200 bg-white px-3.5 text-sm placeholder:text-zinc-400 transition-colors focus:border-violet-400 focus:outline-none focus:ring-2 focus:ring-violet-500/10";

export default function Login() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try { await login(email, password); } catch (err) { setError(formatApiErrorDetail(err.response?.data?.detail)); }
    setBusy(false);
  };

  return (
    <div className="grid min-h-screen bg-[#FAF9F6] lg:grid-cols-[1.1fr_1fr]">
      <div data-testid="login-photo-panel" className="gold-panel login-photo hidden flex-col justify-between p-12 text-white lg:flex">
        <div className="flex items-center gap-3">
          <span data-testid="login-logo" className="flex h-10 w-10 items-center justify-center rounded-lg bg-[#8B7356] text-sm font-extrabold leading-none text-[#F8F4EE]">JOV</span>
          <div className="leading-tight"><div className="text-sm font-bold">JOV Event</div><div className="text-xs text-white/70">Event CRM</div></div>
        </div>
        <div className="max-w-lg">
          <h1 className="text-4xl font-bold leading-[1.15] tracking-tight">Every event, from brief to closure, in one place.</h1>
          <div className="mt-8 flex flex-wrap gap-2">
            {STAGES.map((s) => (
              <span key={s} className="flex items-center gap-2 rounded-full bg-white/10 px-3 py-1.5 text-xs font-medium"><span className="h-2 w-2 rounded-full" style={{ background: STAGE_COLOR[s] }} />{s}</span>
            ))}
          </div>
        </div>
        <div className="text-xs text-white/60">JOV Event · Event CRM</div>
      </div>
      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm space-y-5 rounded-2xl border border-zinc-100 bg-white p-8 shadow-sm" data-testid="login-form">
          <div>
            <h2 className="text-2xl font-bold tracking-tight text-zinc-900">Welcome back</h2>
            <p className="mt-1 text-sm text-zinc-500">Sign in with the login shared by your administrator.</p>
          </div>
          <div className="space-y-3">
            <input data-testid="login-email-input" className={inputCls} placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
            <input data-testid="login-password-input" className={inputCls} type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          {error && <div data-testid="login-error" className="rounded-lg bg-rose-50 px-3 py-2 text-sm text-rose-600">{error}</div>}
          <Button data-testid="login-submit-button" disabled={busy || !email || !password} className="h-11 w-full">
            {busy ? "Signing in…" : "Sign in"}
          </Button>
        </form>
      </div>
    </div>
  );
}
